import LodChlSelect from "components/select/lod/lodChl";
import RmNmSelect from "components/select/rm/rmNo";
import DatePick from "components/datePick";
import TableRow from "components/rows/tableRow";
import Select from "components/select";
import { dateTyps } from "components/utils/option";
import { useTranslation } from "react-i18next";
import { SEARCH_FORM_ID_ROOM_CANCEL_RESV } from "components/constent";
import { useResvCancelFilterContext } from "./context";
import RmOlkCd from "components/select/rm/rmOlkCd";
import RmTypCd from "components/select/rm/rmTypCd";
import { useSubmit } from "./handles";
import Cell from "components/rows/cell";
import DateRangePicker from "components/datePicker";

export default function SearchForm() {
  const { t } = useTranslation();
  const { filters, onChange, onSelect, onPickDate, onReset } =
    useResvCancelFilterContext();
  const { onSubmit } = useSubmit();

  return (
    <form
      id={SEARCH_FORM_ID_ROOM_CANCEL_RESV}
      onSubmit={onSubmit}
      onReset={onReset}
    >
      <table>
        <tbody>
          {/* <TableRow title={t("row_ttl_rm_inf")}>
            <ul>
              <li>
                <label htmlFor="">{t("lbl_rm_nm")}</label>
                <RmNmSelect
                  isReset={!filters.rmNo}
                  select={(rmNo) => {
                    onSelect("rmNo", rmNo);
                  }}
                />
              </li>
              <li>
                <label htmlFor="">{t("lbl_rm_typ")}</label>
                <RmTypCd
                  isReset={!filters.rmTypCd}
                  select={(rmTypCd) => onSelect("rmTypCd", rmTypCd)}
                />
              </li>
              <li>
                <label htmlFor="">{t("lbl_rm_olk")}</label>
                <RmOlkCd
                  isReset={!filters.rmOlkCd}
                  select={(rmOlkCd) => onSelect("rmOlkCd", rmOlkCd)}
                />
              </li>
            </ul>
          </TableRow> */}
          <TableRow title={t("row_ttl_rm_pd")}>
            <ul>
              {/* <li>
                <label htmlFor="">{t("lbl_rmpd_chl")}</label>
                <LodChlSelect
                  isReset={!filters.lodChlCd}
                  select={(lodChlCd) => onSelect("lodChlCd", lodChlCd)}
                />
              </li> */}
              <li>
                <label htmlFor="">{t("lbl_filter_dt")}</label>
                <Select
                  name={"dateTyp"}
                  defaultValue={dateTyps[0]}
                  styles="bg-white border-1"
                  options={dateTyps}
                  isReset={!filters.dateTyp}
                  isInitialData={false}
                  onSelect={(option) => onSelect("dateTyp", option.code)}
                />
              </li>
              <li>
                {/* <DatePick
                  startNm={"sDt"}
                  endNm={"eDt"}
                  defaultValue={[filters?.sDt, filters?.eDt]}
                  onPickDate={onPickDate}
                /> */}
                <DateRangePicker
                  defaultStart={filters?.sDt}
                  defaultEnd={filters?.eDt}
                  onChange={onPickDate}
                />
              </li>
            </ul>
          </TableRow>
          <TableRow title={"고객정보"}>
            <ul>
              <li>
                <Cell
                  label={t("lbl_cst_nm")}
                  dataTyp="C"
                  name="resvCstFstnm"
                  value={filters.resvCstFstnm}
                  onChange={(e) =>
                    onChange("resvCstFstnm", e.currentTarget.value)
                  }
                />
              </li>
              <li>
                <Cell
                  label={t("lbl_cst_phone")}
                  name="resvCstMblNo"
                  value={filters.resvCstMblNo}
                  dataTyp="C"
                  onChange={(e) =>
                    onChange("resvCstMblNo", e.currentTarget.value)
                  }
                />
              </li>
            </ul>
          </TableRow>
          {/* <TableRow title={t("manager_man_row")}>
            <ul>
              <li>
                <Cell
                  label={t("lbl_mem_nm")}
                  name="memFstnm"
                  value={filters.memFstnm}
                  dataTyp="C"
                  onChange={(e) => onChange("memFstnm", e.currentTarget.value)}
                />
              </li>
              <li>
                <Cell
                  label={t("lbl_mem_phone_no")}
                  name="memMobNo"
                  value={filters.memMobNo}
                  dataTyp="C"
                  onChange={(e) => onChange("memMobNo", e.currentTarget.value)}
                />
              </li>
            </ul>
          </TableRow> */}
        </tbody>
      </table>
    </form>
  );
}

const options = [
  {
    ko: "회원이름",
    en: "Member Name",
    value: "resvCstFstnm",
    code: "resvCstFstnm",
  },
  {
    ko: "회원전화번호",
    en: "Member Phone Number",
    value: "resvCstMblNo",
    code: "resvCstMblNo",
  },
  {
    ko: "고객이름",
    en: "Customer Name",
    value: "memFstnm",
    code: "memFstnm",
  },
  {
    ko: "고객전화번호",
    en: "Customer Phone Number",
    value: "memMobNo",
    code: "memMobNo",
  },
];
